import React from 'react'

const ItemStatus = ({ status, isCompleted, onClick }) => {
  let label = ''
  let textColor = 'black'

  switch (status) {
    case 'APPROVED':
      label = 'Approved'
      break
    case 'REJECTED':
      label = 'Rejected'
      break
    case 'ACKNOWLEDGE':
      label = 'Acknowledgement'
      textColor = onClick ? (isCompleted ? 'rgb(233, 142, 51)' : 'rgb(29, 140, 225)') : 'black'
      break
    case 'ON DELIVERY':
      label = 'On Delivery'
      break
    case 'COMPLETED':
      label = 'Completed'
      break
    case 'CANCELED':
      label = 'Canceled'
      break
  }

  return (
    <p
      style={{
        color: textColor,
        marginBottom: 0,
        cursor: status === 'ACKNOWLEDGE' && onClick ? 'pointer' : 'default'
      }}
      onClick={onClick}
    >
      {label}
    </p>
  )
}

export default ItemStatus
